import { lazy } from "react";
import { Navigate, createBrowserRouter } from "react-router";
import { AppShell } from "./components/AppShell";
import { APP_BASENAME, IS_DEV } from "./config";

// Маршруты — порт ROUTE_MAP/route() из app-core.js. basename "/lab" (приложение под /lab/, B2).
// Деталки секций (:id) — порт DETAIL_BASES. Админка только на dev (порт IS_DEV-гарда). Неизвестное → дашборд.
// Code-splitting по маршруту (§13.4 Ф4): страницы грузятся лениво (Suspense-граница в AppShell).
const Strategies = lazy(() => import("./pages/Strategies").then((m) => ({ default: m.Strategies })));
const StrategyDetail = lazy(() => import("./pages/StrategyDetail").then((m) => ({ default: m.StrategyDetail })));
const Runs = lazy(() => import("./pages/Runs").then((m) => ({ default: m.Runs })));
const RunDetail = lazy(() => import("./pages/RunDetail").then((m) => ({ default: m.RunDetail })));
const Marketplace = lazy(() => import("./pages/Marketplace").then((m) => ({ default: m.Marketplace })));
const MarketDetail = lazy(() => import("./pages/MarketDetail").then((m) => ({ default: m.MarketDetail })));
const Settings = lazy(() => import("./pages/Settings").then((m) => ({ default: m.Settings })));
const Dashboard = lazy(() => import("./pages/Dashboard").then((m) => ({ default: m.Dashboard })));
const Admin = lazy(() => import("./pages/Admin").then((m) => ({ default: m.Admin })));
const Lab = lazy(() => import("./pages/Lab").then((m) => ({ default: m.Lab })));
const adminOr404 = (el: React.ReactNode) => (IS_DEV ? el : <Navigate to="/" replace />);

export const router = createBrowserRouter(
  [
    {
      path: "/",
      element: <AppShell />,
      children: [
        { index: true, element: <Dashboard /> },
        { path: "single", element: <Lab mode="single" /> },
        { path: "cross", element: <Lab mode="cross" /> },
        { path: "strategies", element: <Strategies /> },
        { path: "strategies/:id", element: <StrategyDetail /> },
        { path: "runs", element: <Runs /> },
        { path: "runs/:id", element: <RunDetail /> },
        { path: "marketplace", element: <Marketplace /> },
        { path: "marketplace/:id", element: <MarketDetail /> },
        { path: "settings", element: <Settings /> },
        { path: "admin", element: adminOr404(<Admin />) },
        { path: "admin/:tab", element: adminOr404(<Admin />) },
        { path: "*", element: <Navigate to="/" replace /> },
      ],
    },
  ],
  { basename: APP_BASENAME },
);
